import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { UserContextProvider } from "./contextAPI/UserContext";
import { ListContextProvider } from "contextAPI/ListsContext";
import { TrdContextProvider } from "contextAPI/TrdContext";
import { FieldsRecordContextProvider } from "contextAPI/FieldsRecordContext";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { RecordDetailContextProvider } from "contextAPI/RecordDetailContext";
import { WorkflowContextProvider } from "contextAPI/WorkflowContext";
import { FormsContextProvider } from "contextAPI/formsContext";
import "./assets/base.scss";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./config/configureStore";
import App from "./App";

const store = configureStore();

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <UserContextProvider>
          <WorkflowContextProvider>
            <TrdContextProvider>
              <RecordDetailContextProvider>
                <ListContextProvider>
                  <FieldsRecordContextProvider>
                    <FormsContextProvider>
                      <App />
                    </FormsContextProvider>
                  </FieldsRecordContextProvider>
                </ListContextProvider>
              </RecordDetailContextProvider>
            </TrdContextProvider>
          </WorkflowContextProvider>
        </UserContextProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>,

  document.getElementById("root")
);
reportWebVitals();
